export default __webpack_public_path__ + "static/media/logo.704ab2e0.png";